module.exports = __webpack_public_path__ + "static/media/iphone 12.571538e0.jpg";